import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { initI18n } from '../../../utils';
import { Land, Takeoff } from './../../../Icons/Icons';
import { useTranslation } from 'react-i18next';
initI18n('FlightInfoCardPoint');
const FlightInfoCardPoint = ({ time, airport, terminal, departure, mobile }) => {
    const { FlightInfoCardPoint: css } = useTheme('FlightInfoCard');
    const { t } = useTranslation('FlightInfoCard');
    return !mobile ? (React.createElement("div", { className: cn(css.wrapper, { [css.wrapper_departure]: departure }) },
        React.createElement("div", { className: cn(css.airport, { [css.airport_departure]: departure }) },
            React.createElement("div", null, airport.title),
            React.createElement("div", null, terminal && `${t('Terminal')} ${terminal}`)),
        React.createElement("div", { className: cn(css.time) }, time))) : (React.createElement("div", { className: cn(css.wrapper_mobile) },
        React.createElement("div", { className: cn(css.plane) }, departure ? Takeoff : Land),
        React.createElement("div", { className: cn(css.time) }, time),
        React.createElement("div", { className: cn(css.airport) },
            airport.title,
            terminal && (React.createElement(React.Fragment, null,
                ",",
                ' ',
                React.createElement("span", { className: css.airport_terminal },
                    t('Terminal'),
                    " ",
                    terminal))))));
};
export default FlightInfoCardPoint;
